import script from "./CodeViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeViewer.vue?vue&type=script&setup=true&lang=js"

import "./CodeViewer.vue?vue&type=style&index=0&id=cc0637c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc0637c2"]])

export default __exports__